import { Component, Input } from '@angular/core';
import { BackgroundColor, LogoSize } from '@freelancer/ui/logo';
import { PictureDisplay } from '@freelancer/ui/picture';

@Component({
  selector: 'app-navigation-empty',
  template: `
    <div class="NavigationRoot" [attr.data-transparent]="transparent">
      <fl-container class="NavigationContainer" flTrackingSection="Navigation">
        <fl-button
          class="LogoButton"
          link="/"
          display="block"
          flTrackingLabel="Logo"
        >
          <fl-logo
            [backgroundColor]="
              darkMode || transparent
                ? BackgroundColor.DARK
                : BackgroundColor.LIGHT
            "
            [size]="LogoSize.SMALL"
          ></fl-logo>
        </fl-button>
      </fl-container>
    </div>
  `,
  styleUrls: ['./navigation-empty.component.scss'],
})
export class NavigationEmptyComponent {
  BackgroundColor = BackgroundColor;
  LogoSize = LogoSize;
  PictureDisplay = PictureDisplay;

  @Input() darkMode: boolean;
  @Input() transparent: boolean;
}
